import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { styled } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { ToolManager } from '~/engine/tool/ToolManager';

const ViewportFullScreenIcon = styled(OpenInFullIcon)`
    color: ${({ theme }) => theme.palette.text.primary};
    cursor: default;
    pointer-events: auto;
`;

interface SwapToFullScreenProps {
    showFullscreen: boolean;
    setShowFullscreen: (arg0: boolean) => void;
}

const SwapToFullScreen = ({
    showFullscreen,
    setShowFullscreen,
}: SwapToFullScreenProps) => {
    const primaryImage = useRecoilValue(primaryImageState);
    const isEnabled = (): boolean =>
        !ToolManager.getActiveTool()?.isActionInProgress();

    return (
        primaryImage && (
            <ViewportFullScreenIcon
                onClick={() => {
                    if (isEnabled()) {
                        setShowFullscreen(!showFullscreen);
                    }
                }}
                onMouseEnter={(event) => {
                    if (isEnabled()) {
                        event.currentTarget.style.cursor = 'pointer';
                    }
                }}
                onMouseLeave={(event) => {
                    event.currentTarget.style.cursor = 'default';
                }}
                data-testid="full-screen-toggle"
            />
        )
    );
};

export default SwapToFullScreen;
